<template>
  <div class="map" v-if="coordinates">
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label> Ubica tu dirección: </label>
          <div class="search">
            <gmap-autocomplete
              ref="gmapAutocomplete"
              id="gmapAutocomplete"
              class="autocomplete"
              placeholder="Ingrese dirección"
              @place_changed="setPlace"
              :select-first-on-enter="true"
              :options="{
                fields: ['geometry', 'address_components', 'name', 'formatted_address']
              }"
            >
            </gmap-autocomplete>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <gmap-map
          ref="gmap"
          style="width: 100%; height: 400px"
          :zoom="setZoom"
          :center="currentLocation"
          :options="{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: true,
            fullscreenControl: true,
            disableDefaultUi: true
          }"
        >
          <gmap-marker
            ref="gmapMarker"
            id="gmapMarker"
            :position="currentLocation"
            :title="coordinates.location"
          ></gmap-marker>
        </gmap-map>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MapComponent',
  props: {
    coordinates: {
      type: Object,
      default: () => {}
    },
    typeModal: {
      type: String,
      default: 'add'
    }
  },
  watch: {
    place(value) {
      this.setCoordinates(value);
    }
  },
  data() {
    return {
      setZoom: 1,
      place: null,
      currentLocation: {
        lat: this.coordinates ? this.coordinates.lat : 0,
        lng: this.coordinates ? this.coordinates.lng : 0,
        location: this.coordinates ? this.coordinates.location : ''
      }
    };
  },
  methods: {
    setPlace(place) {
      this.place = place;
      if (!place) return;
      this.setZoom = 12;
      this.currentLocation.location = place.formatted_address;
    },
    setCoordinates(value) {
      this.currentLocation = {
        lat: value.geometry.location.lat(),
        lng: value.geometry.location.lng(),
        location: value.formatted_address
      };
      this.$emit('assignCoordinates', this.currentLocation);
    },
    defaultValues() {
      if (this.coordinates) {
        this.currentLocation.lat = this.coordinates.lat;
        this.currentLocation.lng = this.coordinates.lng;
        this.currentLocation.location = this.coordinates.location;
        this.setZoom = this.typeModal === 'edit' ? 12 : 1;
      }
    }
  },
  mounted() {
    this.defaultValues();
  }
};
</script>
<style lang="scss">
.pac-container {
  background-color: white !important;
  position: absolute !important;
  z-index: 1051 !important;
}
input.pac-target-input {
  width: 100% !important;
  color: #495057 !important;
  background-color: #fff !important;
  background-clip: padding-box !important;
  border: 1px solid #ced4da !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  border-radius: 0.2rem !important;
  padding: 4px 10px;
}
label {
  margin-bottom: 0.25rem !important;
  display: flex;
}
.map {
  .search {
    display: flex;
    flex-direction: row;
  }
  .autocomplete {
    width: 100%;
  }
}
</style>
